import { render, staticRenderFns } from "./RelacaoContratacoesEntregasGerente.vue?vue&type=template&id=5cc9242e"
import script from "./RelacaoContratacoesEntregasGerente.vue?vue&type=script&lang=js"
export * from "./RelacaoContratacoesEntregasGerente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports